const mutations = {
  SET_PAGE_SIZE(state, { pageSize }) {
    state.pageSize = pageSize;
    state.currentPage = 0;
  },

  SET_CURRENT_PAGE(state, { currentPage }) {
    state.currentPage = currentPage;
  },

  SET_ORDERING(state, { ordering }) {
    state.ordering = ordering;
    state.currentPage = 0;
  },

  SET_DATE_RANGE(state, dateRange) {
    state.dateRange = dateRange;
  },

  SET_LEARNERS(state, { learners }) {
    state.learners = Array.isArray(learners) ? learners : [];
  },

  SET_SEARCH_QUERY(state, query) {
    state.learnersFilters = {
      ...state.learnersFilters,
      query,
    };
  },

  SET_COLUMNS(state, columns) {
    state.columns = columns;
  },

  SET_CREDITS_UNIT(state, creditsUnit) {
    state.creditsUnit = creditsUnit;
  },
};

export default mutations;
